// extracted by mini-css-extract-plugin
export default {"box":"DevelopersPage_box__bodxC","img":"DevelopersPage_img__vRIfi"};